import React, { useContext } from "react";

import { Modal } from "../components/_common";
import { Context as ModalContext } from "../context/ModalContext";

const ModalController = () => {
  const {
    state: { hidden, component, title },
    closeModal
  } = useContext(ModalContext);

  return (
    <Modal title={title} open={!hidden} onClose={closeModal}>
      {component}
    </Modal>
  );
};

export default ModalController;
